var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"footer d-none d-lg-block"},[_c('div',{staticClass:"container"},[_c('span',{staticClass:"text-muted"},[_vm._v("(c) 2022 Laurent Coustet (Version: "+_vm._s(_vm.version)+")")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }